const LK_Import =({color,width,height})=>{
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill={color}  width={width} height={height} viewBox="0 0 116.99 116.99">
            {/* <defs>
                <style>
                .cls-1 {
                    fill: #005c8e;
                    stroke-width: 0px;
                }
                </style>
            </defs> */}
            <g>
                <path class="cls-1" d="M42.92,42.5l27.71,16-27.71,16v-32M38.59,34.99v47s40.71-23.5,40.71-23.5l-40.71-23.5h0Z"/>
                <rect class="cls-1" x=".45" y="56.33" width="39" height="4.33"/>
            </g>
            <path class="cls-1" d="M111.53,30.45l-25.45-25.45-5-5H25.55v34.99h5V5h46.99v19.55c0,7.98,6.47,14.44,14.44,14.44h19.55v72.99H30.55v-29.99h-5v34.99h90.99V35.46l-5-5ZM91.99,33.99c-5.2,0-9.44-4.23-9.44-9.44V8.54l25.45,25.45h-16.01Z"/>
      </svg>
    );
};

export default LK_Import;
